var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { FiPlus } from "react-icons/fi";
import useAuth from "../../../hooks/useAuth";
import api from "../../../services/api";
import Modaladdress from "../../Modals/ModalAddress";
import styles from './styles.module.scss';
import { Table } from 'template/lib';
var AddressTab = function (props) {
    var _a = useState(0), idtoChange = _a[0], setIdToChange = _a[1];
    var _b = useState(1), page = _b[0], setPage = _b[1];
    var _c = useState(10), pageSize = _c[0], setPageSize = _c[1];
    var _d = useState(false), hasNext = _d[0], setHasNext = _d[1];
    var _e = useState(1), totalPages = _e[0], setTotalPages = _e[1];
    var _f = useState([]), items = _f[0], setItems = _f[1];
    var _g = useState(), adresState = _g[0], setAdressState = _g[1];
    var _h = useState(false), refresh = _h[0], setRefresh = _h[1];
    var _j = useState(true), loading = _j[0], setLoading = _j[1];
    var login = useAuth().login;
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    useEffect(function () {
        setLoading(true);
        setItems([]);
        api.get("/companies/" + props.companyId + "/addresses", config).then(function (response) {
            setItems(response.data);
        }).then(function () { return setLoading(false); });
        if (refresh === true) {
            setRefresh(false);
        }
    }, [props.companyId, refresh, page, pageSize]);
    useEffect(function () {
        if (idtoChange == 0) {
            return;
        }
        setLoading(true);
        api.put("/companies/" + props.companyId + "/addresses/" + idtoChange, adresState, config).then(function (response) {
            setItems(response.data);
        }).then(function () { return setLoading(false); });
    }, [adresState, idtoChange]);
    var _k = useState(false), modalIsOpenAddress = _k[0], setIsOpenAddress = _k[1];
    function handleOpenModalAddress() {
        setIsOpenAddress(true);
    }
    function handlecloseModalAddress() {
        setIsOpenAddress(false);
    }
    var menuBtn = [
        {
            fn: function () { return handleOpenModalAddress(); },
            icon: _jsx(FiPlus, { size: 16 }, void 0),
            id: 1,
            title: 'Novo Endereço'
        }
    ];
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: styles.container }, { children: _jsx(Table, { setSize: setPageSize, hasNext: hasNext, page: page, setPage: setPage, data: items, setData: setItems, loading: loading, changeExistentContent: setAdressState, totalPAges: totalPages, title: 'Endere\u00E7os', refresh: setRefresh, headerButtons: menuBtn, editable: true, setIdToChange: setIdToChange, columns: [
                        { label: 'Estado', key: 'select_state' },
                        { label: 'Cidade', key: 'select_city' },
                        { label: 'Rua', key: 'street' },
                        { label: 'Bairro', key: 'neighborhood' },
                        { label: 'Número', key: 'number' },
                        { label: 'CEP', key: 'zipcode' }
                    ] }, void 0) }), void 0), _jsx(Modaladdress, { setRefresh: setRefresh, companyId: props.companyId, modalIsOpenAddress: modalIsOpenAddress, handleOpenModalAddress: handleOpenModalAddress, handlecloseModalAddress: handlecloseModalAddress }, void 0)] }, void 0));
};
export default AddressTab;
